\:host
    width: 100%